import React, { Component } from "react";

import { parseIsoDate } from "@formant/date-fns/parseIsoDate";
import { IsoDate } from "@formant/core/model/IsoDate";

import { formatDate } from "../../utils/formatDate";
import { formatDateTime } from "../../utils/formatDateTime";
import * as styles from "./RowDate.scss";

export interface IRowDateProps {
    date?: IsoDate;
    showTime?: boolean;
}

export class RowDate extends Component<IRowDateProps> {
    public render() {
        const { date, showTime } = this.props;
        if (!date) {
            return false;
        }
        return (
            <span className={styles["row-date"]}>
                {showTime
                    ? formatDateTime(parseIsoDate(date))
                    : formatDate(parseIsoDate(date))}
            </span>
        );
    }
}
